export default __webpack_public_path__ + "static/media/continueRepair.17192262.png";